import React from "react";
import MyFav from "../components/favorities/MyFav";

const Favorites = () => {
  return (
    <div className="page">
      <MyFav />
    </div>
  );
};

export default Favorites;
